<template>
  <v-col cols="12" sm="6" md="6" lg="3">
    <v-card>
      <v-progress-linear
        color="primary"
        indeterminate
        v-if="$apollo.loading"
      ></v-progress-linear>
      <v-toolbar flat dense>
        <span class="text-subtitle-1">Inventory</span>
      </v-toolbar>
      <div class="stat-data">
        <div class="main-stat" :class="getDifferenceTextClass()">
          <v-icon
            :color="getDifferenceIconColor()"
            v-if="totalDifference < 0"
            small
            class="mr-1"
            >mdi-arrow-down-thick</v-icon
          >
          <v-icon
            :color="getDifferenceIconColor()"
            v-if="totalDifference > 0"
            small
            class="mr-1"
            >mdi-arrow-up-thick</v-icon
          >
          {{ totalDifference }}
        </div>
        <span class="stat-data-desc">
          <span class="count-text">{{ totalRetained }}</span>
          <span class="label-text">Retained</span> /
          <span class="count-text">{{ totalClosed }}</span>
          <span class="label-text">Closed</span>
        </span>
      </div>
    </v-card>
  </v-col>
</template>

<script>
import gql from "graphql-tag";
import { mapGetters } from "vuex";

export default {
  apollo: {
    comparison: {
      query: gql`
        query OrgHomeStatsInventory($startDate: String!, $endDate: String!) {
          comparison: totalInventoryComparisonInPeriod(
            startDate: $startDate
            endDate: $endDate
          ) {
            totalClosedCases
            totalRetainedCases
          }
        }
      `,
      variables() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
        };
      },
      skip() {
        return this.startDate === null || this.endDate === null;
      },
    },
  },
  computed: {
    ...mapGetters(["currentUser", "startDate", "endDate"]),
    totalRetained() {
      if (!this.comparison) return 0;
      return this.comparison.totalRetainedCases;
    },
    totalClosed() {
      if (!this.comparison) return 0;
      return this.comparison.totalClosedCases;
    },
    totalDifference() {
      return this.totalRetained - this.totalClosed;
    },
  },
  methods: {
    getDifferenceTextClass() {
      if (this.totalDifference > 0) return "success--text";
      if (this.totalDifference < 0) return "error--text";
      return "";
    },
    getDifferenceIconColor() {
      if (this.totalDifference > 0) return "success";
      if (this.totalDifference < 0) return "error";
      return "grey";
    },
  },
};
</script>

<style lang="scss">
// Enhanced typography for better readability
.main-stat {
  font-size: 2rem !important;
  font-weight: 600 !important;
  line-height: 1.2;
  display: flex;
  align-items: center;
}

.count-text {
  font-weight: 600 !important;
  color: rgba(0, 0, 0, 0.87) !important;
}

.label-text {
  font-weight: 500 !important;
  color: rgba(0, 0, 0, 0.75) !important;
  margin-left: 2px;
  margin-right: 4px;
}

.stat-data-desc {
  font-weight: 500 !important;
  color: rgba(0, 0, 0, 0.75) !important;
}
</style>
